import React,{useContext} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import withMediaQuery from "flexbiz-core/components/withMediaQuery";
import Container from './Container';
import AppContainer from 'flexbiz-core/components/AppContainer';
import BottomNavigation from "./BottomNavigation";
import Dashboard from "./DashboardBDS";
import DashboardDef from "flexbiz-core/components/dashboard/Dashboard";
import AuthContext from "flexbiz-core/components/auth/Context";
function HomePage(props) {
  const context = useContext(AuthContext);
  let Dash,Cont;
  switch (context.queryParams?.for_agent) {
    case "8":
      Dash = Dashboard
      Cont = AppContainer
      break;
    default: {
      Dash = DashboardDef;
      Cont = Container
    }
  }
  return (
    <Cont 
      {...props} 
      requireLogin
      contentSx={{ overflowY: 'hidden' }}
    >
      <Dash/>
      <BottomNavigation code={"DASHBOARD"} />
    </Cont>
  );
}
HomePage.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any
};

export default withRouter(withMediaQuery('(max-width:540px)')(HomePage));